import { useEffect } from "react";
import {
  Route,
  Routes,
  useLocation,
  useNavigate,
  useNavigationType,
  useParams,
} from "react-router-dom";
import Carrinho from "./pages/Carrinho/Carrinho";
import CheckoutPagamentoAprovado from "./pages/CheckoutApproved/CheckoutPagamentoAprovado";
import CheckoutDados from "./pages/CheckoutData/CheckoutDados";
import CheckoutEndEntrega from "./pages/CheckoutDelivery/CheckoutEndEntrega";
import CheckoutPagamentoCartaoErro from "./pages/CheckoutError/CheckoutPagamentoCartaoErro";
import CheckoutPagamentoCartao from "./pages/CheckoutPayment/CheckoutPagamentoCartao";
import CheckoutPagamentoBoletoCod from "./pages/CheckoutPaymentPix/CheckoutPagamentoBoletoCod";
import CheckoutPagamentoCartaoProc from "./pages/CheckoutProcess/CheckoutPagamentoCartaoProc";
import { useCheckout } from "./context/CheckoutContext";
import { ToastContainer } from "react-toastify";
import { initializeGTM } from "./utils/gtm";

function App() {
  const action = useNavigationType();
  const location = useLocation();
  const pathname = location.pathname;

  useEffect(() => {
    initializeGTM();
  }, []);

  useEffect(() => {
    if (action !== "POP") {
      window.scrollTo(0, 0);
    }
  }, [action, pathname]);



  useEffect(() => {
    let title = "";
    let metaDescription = "";

    switch (pathname) {
      case "/":
        title = "";
        metaDescription = "";
        break;
      case "/54checkoutpagamentocartaoerro":
        title = "";
        metaDescription = "";
        break;
      case "/62checkoutpagamentoboletocod":
        title = "";
        metaDescription = "";
        break;
      case "/53checkoutpagamentoaprovado":
        title = "";
        metaDescription = "";
        break;
      case "/52checkoutpagamentocartaoprocessando":
        title = "";
        metaDescription = "";
        break;
      case "/5checkoutpagamentocartao":
        title = "";
        metaDescription = "";
        break;
      case "/4checkoutendentrega":
        title = "";
        metaDescription = "";
        break;
      case "/3checkoutdados":
        title = "";
        metaDescription = "";
        break;
      case "/22carrinhopreenchido":
        title = "";
        metaDescription = "";
        break;
      case "/2carrinhopreenchido":
        title = "";
        metaDescription = "";
        break;
      case "/11carrinho":
        title = "";
        metaDescription = "";
        break;
      case "/1carrinho":
        title = "";
        metaDescription = "";
        break;
      case "/1carrinho1":
        title = "";
        metaDescription = "";
        break;
      case "/6checkoutpagamentoboleto":
        title = "";
        metaDescription = "";
        break;
    }

    if (title) {
      document.title = title;
    }

    if (metaDescription) {
      const metaDescriptionTag: HTMLMetaElement | null = document.querySelector(
        'head > meta[name="description"]'
      );
      if (metaDescriptionTag) {
        metaDescriptionTag.content = metaDescription;
      }
    }
  }, [pathname]);
  

  return (
    <>
    <Routes>
      <Route
        path="/checkout-pagamento-erro"
        element={<CheckoutPagamentoCartaoErro />}
      />
      <Route
        path="/checkout-pagamento-boleto"
        element={<CheckoutPagamentoBoletoCod />}
      />
      <Route
        path="/checkout-pagamento-aprovado"
        element={<CheckoutPagamentoAprovado />}
      />
      <Route
        path="/checkout-pagamento-processando"
        element={<CheckoutPagamentoCartaoProc />}
      />
      <Route
        path="/checkout-pagamento"
        element={<CheckoutPagamentoCartao />}
      />
      <Route 
        path="/checkout-entrega"
        element={<CheckoutEndEntrega />}
      />
      <Route 
        path="/checkout-dados"
        element={<CheckoutDados />}
      />
      <Route 
        path="/11carrinho"
        element={<Carrinho />}
      />
      <Route
        path="/checkout-pagamento-erro/:slug"
        element={<CheckoutPagamentoCartaoErro />}
      />
      <Route
        path="/checkout-pagamento-boleto/:slug"
        element={<CheckoutPagamentoBoletoCod />}
      />
      <Route
        path="/checkout-pagamento-aprovado/:slug"
        element={<CheckoutPagamentoAprovado />}
      />
      <Route 
        path="/checkout-pagamento-processando/:slug/:planSlug/:productSlug"
        element={<CheckoutPagamentoCartaoProc />}
      />
      <Route 
        path="/checkout-pagamento-processando/:planSlug/:productSlug"
        element={<CheckoutPagamentoCartaoProc />}
      />
      <Route
        path="/checkout-pagamento-processando/:slug"
        element={<CheckoutPagamentoCartaoProc />}
      />
      <Route 
        path="/checkout-pagamento/:slug/:planSlug/:productSlug"
        element={<CheckoutPagamentoCartao />}
      />
      <Route 
        path="/checkout-pagamento/:planSlug/:productSlug"
        element={<CheckoutPagamentoCartao />}
      />
      <Route
        path="/checkout-pagamento/:slug"
        element={<CheckoutPagamentoCartao />}
      />
      <Route 
        path="/checkout-entrega/:slug/:planSlug/:productSlug"
        element={<CheckoutEndEntrega />}
      />
      <Route 
        path="/checkout-entrega/:planSlug/:productSlug"
        element={<CheckoutEndEntrega />}
      />
      <Route 
        path="/checkout-entrega/:slug"
        element={<CheckoutEndEntrega />}
      />
      <Route 
        path="/checkout-dados/:slug/:planSlug/:productSlug"
        element={<CheckoutDados />}
      />
      <Route 
        path="/checkout-dados/:planSlug/:productSlug"
        element={<CheckoutDados />}
      />
      <Route 
        path="/checkout-dados/:slug"
        element={<CheckoutDados />}
      />
      <Route 
        path="/11carrinho/:slug"
        element={<Carrinho />}
      />
      <Route path="/:slug/:planSlug/:productSlug" element={ <Carrinho /> } />
      <Route path="/:planSlug/:productSlug" element={ <Carrinho /> } />
      <Route path="/:slug" element={ <Carrinho /> } />
      <Route path="/" element={ <Carrinho /> } />
    </Routes>
    <ToastContainer
      position="top-right"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      limit={1}
    />
  </>
  );
}
export default App;
